import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {TrophyRepositoryService} from "../../../services/trophy-repository.service";
import {OrganizationTrophyItem} from "../../../interfaces/organization-trophy-item";

@Component({
  selector: 'brt-school-class-compare-block-trophies',
  templateUrl: './school-class-compare-block-trophies.component.html',
  styleUrls: ['./school-class-compare-block-trophies.component.scss']
})
export class SchoolClassCompareBlockTrophiesComponent implements AfterViewInit {
  @ViewChild("mainEl") mainEl!: ElementRef;
  @Input('data') set setData(data: {className: string, trophies: OrganizationTrophyItem[]}[]) {
    this.extendData(data);
  };

  data: any;

  currentSlide = 0;
  slidesPerView = 4;
  isPrevButtonVisible = false;
  isNextButtonVisible = false;

  isShowNavigation = false;

  constructor(private trophyRepositoryService: TrophyRepositoryService) {
  }

  ngAfterViewInit() {
    // const mainElHtml = this.mainEl.nativeElement as HTMLElement;
    // const slidesPerView = getComputedStyle(mainElHtml).getPropertyValue("--slidesPerView");
  }

  async extendData(data: {className: string, trophies: OrganizationTrophyItem[]}[]) {
    const newDataList: any[] = [];
    for(let i = 0; i < data.length; i++) {
      let newTrophiesList: any[] = [];
      for(let j = 0; j < data[i].trophies.length; j++) {
        const trophyExtended = await this.trophyRepositoryService.getTrophyById(data[i].trophies[j].trophyId);
        newTrophiesList.push({...trophyExtended, progress: data[i].trophies[j].percentValue, iconPath: ""});
      }
      newDataList.push({
        className: data[i].className,
        trophies: newTrophiesList,
        totalTrophiesNumber: newTrophiesList.length,
        completedTrophiesNumber: newTrophiesList.filter((trophy) => trophy.progress === 100).length
      });

    }
    this.data = newDataList;

    if(window.innerWidth >= 992) {
      if(this.data.length < 4) {
        this.slidesPerView = this.data.length;
        this.isShowNavigation = false;
      } else {
        this.slidesPerView = 4;
        this.isNextButtonVisible = true;
        this.isShowNavigation = true;
      }
    } else {
      if(this.data.length === 1) {
        this.slidesPerView = 1;
        this.isShowNavigation = false;
      } else {
        this.slidesPerView = 1.4;
        this.isNextButtonVisible = true;
        this.isShowNavigation = true;
      }
    }

  }

  prevSlide() {
    const targetSlide = this.currentSlide - 1;
    if(targetSlide < 0) this.currentSlide = 0;
    else this.currentSlide = targetSlide;

    this.isPrevButtonVisible = this.currentSlide > 0;
    this.isNextButtonVisible = true;
  }

  nextSlide() {
    const targetSlide = this.currentSlide + 1;
    if(targetSlide > Math.ceil(this.data.length - this.slidesPerView)) this.currentSlide = 0;
    else this.currentSlide = targetSlide;

    this.isNextButtonVisible = this.currentSlide < this.data.length - this.slidesPerView;
    this.isPrevButtonVisible = true;
  }
}
